declare namespace $ {

	type $mol_string__value_shm_projects_task_1 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_title_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_projects_task_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_task_3 = $mol_type_enforce<
		ReturnType< $shm_projects_task['Task_title'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__value_shm_projects_task_4 = $mol_type_enforce<
		ReturnType< $shm_projects_task['assignee_id_draft'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_projects_task_5 = $mol_type_enforce<
		ReturnType< $shm_projects_task['assignee_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_form_field__name_shm_projects_task_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_task_7 = $mol_type_enforce<
		ReturnType< $shm_projects_task['Assignee'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__value_shm_projects_task_8 = $mol_type_enforce<
		ReturnType< $shm_projects_task['priority_draft'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_projects_task_9 = $mol_type_enforce<
		ReturnType< $shm_projects_task['priority_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_form_field__name_shm_projects_task_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_task_11 = $mol_type_enforce<
		ReturnType< $shm_projects_task['Priority'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_shm_projects_task_12 = $mol_type_enforce<
		ReturnType< $shm_projects_task['description_draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_projects_task_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_task_14 = $mol_type_enforce<
		ReturnType< $shm_projects_task['Description_draft'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_view__sub_shm_projects_task_15 = $mol_type_enforce<
		ReturnType< $shm_projects_task['editor_action_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_projects_task_16 = $mol_type_enforce<
		ReturnType< $shm_projects_task['priority_meta'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_form_field__name_shm_projects_task_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_task_18 = $mol_type_enforce<
		ReturnType< $shm_projects_task['Priority_meta_text'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_text__text_shm_projects_task_19 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_projects_task_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_agent_message_text__text_shm_projects_task_21 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_result'] >
		,
		ReturnType< $shm_agent_message_text['text'] >
	>
	type $mol_page__title_shm_projects_task_22 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_page_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_task_23 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_projects_task_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_projects_task_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_projects_task_26 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_action_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_projects_task_27 = $mol_type_enforce<
		ReturnType< $shm_projects_task['research'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_projects_task_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_projects_task_29 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_action_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_projects_task_30 = $mol_type_enforce<
		ReturnType< $shm_projects_task['work'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_projects_task_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_projects_task_32 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_action_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_projects_task_33 = $mol_type_enforce<
		ReturnType< $shm_projects_task['work_prerelease'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_projects_task_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_task_35 = $mol_type_enforce<
		ReturnType< $shm_projects_task['edit_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_projects_task_36 = $mol_type_enforce<
		ReturnType< $shm_projects_task['summary_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_task_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_shm_projects_task_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_task_39 = $mol_type_enforce<
		ReturnType< $shm_projects_task['Description_text'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_view__sub_shm_projects_task_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_task_41 = $mol_type_enforce<
		ReturnType< $shm_projects_task['summary_action_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_projects_task_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_task_43 = $mol_type_enforce<
		ReturnType< $shm_projects_task['edit_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_projects_task_chat__run_shm_projects_task_44 = $mol_type_enforce<
		ReturnType< $shm_projects_task['run_data'] >
		,
		ReturnType< $shm_projects_task_chat['run'] >
	>
	type $shm_projects_task_chat__iteration_shm_projects_task_45 = $mol_type_enforce<
		ReturnType< $shm_projects_task['task_iteration'] >
		,
		ReturnType< $shm_projects_task_chat['iteration'] >
	>
	type $shm_projects_task_chat__version_shm_projects_task_46 = $mol_type_enforce<
		ReturnType< $shm_projects_task['project_version'] >
		,
		ReturnType< $shm_projects_task_chat['version'] >
	>
	type $shm_projects_task_chat__workspace_id_shm_projects_task_47 = $mol_type_enforce<
		ReturnType< $shm_projects_task['workspace_id'] >
		,
		ReturnType< $shm_projects_task_chat['workspace_id'] >
	>
	type $shm_projects_task_chat__prompt_shm_projects_task_48 = $mol_type_enforce<
		ReturnType< $shm_projects_task['message_draft'] >
		,
		ReturnType< $shm_projects_task_chat['prompt'] >
	>
	type $shm_projects_task_chat__send_shm_projects_task_49 = $mol_type_enforce<
		ReturnType< $shm_projects_task['send_message'] >
		,
		ReturnType< $shm_projects_task_chat['send'] >
	>
	type $shm_projects_task_chat__after_shm_projects_task_50 = $mol_type_enforce<
		ReturnType< $shm_projects_task['agent_after'] >
		,
		ReturnType< $shm_projects_task_chat['after'] >
	>
	export class $shm_projects_task extends $mol_book2 {
		task_pages( ): readonly(any)[]
		task_page_title( ): string
		task_body( ): readonly(any)[]
		task_title_draft( next?: string ): string
		Task_title( ): $mol_string
		Title_field( ): $mol_form_field
		assignee_id_draft( next?: string ): string
		assignee_options( ): Record<string, any>
		Assignee( ): $mol_select
		Assignee_field( ): $mol_form_field
		priority_draft( next?: string ): string
		priority_options( ): Record<string, any>
		Priority( ): $mol_select
		Priority_field( ): $mol_form_field
		description_draft( next?: string ): string
		Description_draft( ): $mol_textarea
		Description_field( ): $mol_form_field
		editor_action_rows( ): readonly(any)[]
		Editor_actions( ): $mol_view
		task_action_enabled( ): boolean
		research( next?: any ): any
		work( next?: any ): any
		work_prerelease( next?: any ): any
		edit_cancel( next?: any ): any
		summary_rows( ): readonly(any)[]
		priority_meta( ): string
		Priority_meta_text( ): $mol_text
		Priority_meta( ): $mol_form_field
		task_description( ): string
		Description_text( ): $mol_text
		Result_title( ): $mol_view
		task_result( ): string
		Result_text( ): $shm_agent_message_text
		summary_action_rows( ): readonly(any)[]
		edit_open( next?: any ): any
		run_data( next?: any ): any
		task_iteration( ): number
		project_version( ): string
		workspace_id( ): string
		message_draft( next?: string ): string
		send_message( next?: any ): any
		agent_after( ): readonly(any)[]
		project_id( ): string
		task_id( ): string
		pages( ): ReturnType< $shm_projects_task['task_pages'] >
		Details_page( ): $mol_page
		Editor( ): $mol_view
		Research( ): $mol_button_minor
		Work( ): $mol_button_minor
		Work_prerelease( ): $mol_button_minor
		Edit_cancel( ): $mol_button_minor
		Summary( ): $mol_view
		Task_meta( ): $mol_view
		Description_card( ): $mol_form_field
		Result_card( ): $mol_view
		Summary_actions( ): $mol_view
		Edit_open( ): $mol_button_minor
		Agent( ): $shm_projects_task_chat
	}
	
}

//# sourceMappingURL=task.view.tree.d.ts.map